import { RepetitionType } from '#types/schedule';
import { getDayOfWeek } from '#utils/getDayOfWeek';

export function getRepeatType(repetitionType?: RepetitionType['type']) {
  switch (repetitionType) {
    case 'DAILY':
      return '매일';
    case 'WEEKLY':
      return '매주';
    default:
      return '없음';
  }
}

export function getRepeatTitle(repeatType: string, daysOfWeek: number[]) {
  switch (repeatType) {
    case '매일':
      return '매일 반복';
    case '매주':
      return `${repeatType} ${getDayOfWeek(daysOfWeek)}요일 반복`;
    default:
      return '';
  }
}
